export const RenameFile = ( filename ) => {
    const extension = filename.split(".").pop();
    const timeStamp = Math.floor(Date.now() / 1000);
    const newName = `${timeStamp}.${extension}`;
    return newName;
}